export const getPieChart = (data) => {
  let totalSuccessCount = 0;
  let totalFailureCount = 0;

  data.forEach((item) => {
    totalSuccessCount += item.success_count;
    totalFailureCount += item.failure_count;
  });
  const pieData = [
    { name: "Success", value: totalSuccessCount },
    { name: "Failure", value: totalFailureCount },
  ];

  return pieData;
};

export const getAggreatedSourceData = (data) => {
  const aggregatedData = data.reduce((acc, item) => {
    if (!acc[item.source]) {
      acc[item.source] = {
        source: item.source,
        call_count: 0,
        success_count: 0,
        failure_count: 0,
        valpro_pdf_success_count: 0,
        valpro_pdf_fail_count: 0,
      };
    }

    acc[item.source].call_count += item.call_count;
    acc[item.source].success_count += item.success_count;
    acc[item.source].failure_count += item.failure_count;
    acc[item.source].valpro_pdf_success_count += item.valpro_pdf_success_count;
    acc[item.source].valpro_pdf_fail_count += item.valpro_pdf_fail_count;

    return acc;
  }, {});
  return Object.values(aggregatedData);
};

export const getOrderByUserData = (data) => {
  const aggregatedData = {};

  data.forEach((item) => {
    const key = `${item.username}|${item.company}|${item.source}|${item.product}`;
    if (!aggregatedData[key]) {
      // Initialize if not already present
      aggregatedData[key] = {
        username: item.username,
        company: item.company,
        source: item.source,
        product: item.product,
        call_count: 0,
        success_count: 0,
        failure_count: 0,
        valpro_pdf_fail_count: 0,
        valpro_pdf_success_count: 0,
      };
    }

    aggregatedData[key].call_count += item.call_count;
    aggregatedData[key].success_count += item.success_count;
    aggregatedData[key].failure_count += item.failure_count;
    aggregatedData[key].valpro_pdf_fail_count += item.valpro_pdf_fail_count;
    aggregatedData[key].valpro_pdf_success_count +=
      item.valpro_pdf_success_count;
  });

  const aggregatedArray = Object.values(aggregatedData);
  return aggregatedArray;
};

export const getAggregatedByCompanyData = (data) => {
  const aggregatedData = {};

  data.forEach((item) => {
    const key = `${item.company}-${item.source}-${item.product}`;
    if (!aggregatedData[key]) {
      aggregatedData[key] = {
        username: item.username,
        company: item.company,
        source: item.source,
        product: item.product,
        call_count: 0,
        success_count: 0,
        failure_count: 0,
        valpro_pdf_fail_count: 0,
        valpro_pdf_success_count: 0,
      };
    }
    aggregatedData[key].call_count += item.call_count;
    aggregatedData[key].success_count += item.success_count;
    aggregatedData[key].failure_count += item.failure_count;
    aggregatedData[key].valpro_pdf_fail_count += item.valpro_pdf_fail_count;
    aggregatedData[key].valpro_pdf_success_count +=
      item.valpro_pdf_success_count;
  });

  const aggregatedArray = Object.values(aggregatedData);
  return aggregatedArray;
};
